<section class="app-abo-us-des" [id]="AboutUsSection.DESCRIPTION">
  <div class="container app-abo-us-des__con">
    <div class="app-abo-us-des__con__lef" [appAnimate]="'slideInRight'" [speed]="'faster'" [aos]="0.4">
      <h2 class="app-abo-us-des__con__lef__h2">PRO.CONNECT</h2>
      <p class="app-abo-us-des__con__lef__pin">
        to miejsce stworzone z myślą o fryzjerach, którzy pragną rozwijać się nowocześnie, świadomie i z pasją. To
        przestrzeń, gdzie fryzjerzy zdobywają nową wiedzę, inspirują się najnowszymi trendami i doskonalą swoje
        umiejętności, zawsze z szacunkiem dla sztuki fryzjerskiej.
      </p>
      <p class="app-abo-us-des__con__lef__p">
        PRO.CONNECT to nie tylko platforma edukacyjna, ale także dynamiczna społeczność profesjonalistów, którzy dzielą
        się doświadczeniami i wspólnie dążą do zawodowego rozwoju. Dołączając, stałeś się ważną jednostką w naszej
        społeczności, która wspiera się nawzajem, motywuje do osiągania nowych celów i nieustannie inspiruje.
        Niezależnie od tego, czy prowadzisz własny salon, pracujesz na sesjach zdjęciowych, czy dopiero zaczynasz swoją
        drogę w branży, PRO.CONNECT to Twoje miejsce do nauki, wymiany doświadczeń i ciągłej inspiracji. Twój styl i
        pasja towarzyszą Ci w każdym kroku, a platforma PRO.CONNECT pomaga Ci rozwijać się na każdym etapie Twojej
        kariery.
      </p>
    </div>
    <div class="app-abo-us-des__con__rig" [appAnimate]="'slideInLeft'" [speed]="'faster'" [aos]="0.4">
      <img
        class="app-abo-us-des__con__rig__bg"
        [priority]="true"
        alt="background"
        ngSrc="assets/images/pages/about-us/about-us-description-baner.webp"
        [fill]="true"
      />
    </div>
  </div>
</section>
